export const COUNTRIES_INFO = 'COUNTRIES_INFO'
export const PEER_INFO = 'PEER_INFO'
export const NOTIFY_PENDING = 'NOTIFY_PENDING'
export const POSTAL_CODE_CACHE = 'POSTAL_CODE_CACHE'

export default {
    COUNTRIES_INFO,
    PEER_INFO,
    NOTIFY_PENDING,
    POSTAL_CODE_CACHE
}
